export const NAME = "images"
export const FIREBASE_PATH = "images"
export const STORAGE_PATHS = {
  IMAGES: "images",
  OFFER_REQUEST_IMAGES: "offer_requests",
  SELLER_FILES: "files",
}
